import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';

import { BackToLoginLink } from './common/BackToLoginLink';

export const LegacySsoRedirectView = () => {
    const { provider } = useParams<{ provider: string }>();

    const loginUrl = `${window.location.origin}/login`;

    return (
        <div>
            <h2 className="tw-text-l tw-font-semibold tw-mb-8">
                <FormattedMessage id="login.sso.legacy.title" defaultMessage="SSO link has moved" />
            </h2>
            <p className="tw-text-neutral-subdued tw-text-s tw-mb-8">
                <FormattedMessage
                    id="login.sso.legacy.description"
                    defaultMessage="The SSO login URL for {provider} has changed. Please use the new login page to sign in."
                    values={{
                        provider: <strong>{provider}</strong>,
                    }}
                />
            </p>
            <p className="tw-text-neutral-subdued tw-text-s tw-mb-16">
                <FormattedMessage
                    id="login.sso.legacy.newUrl"
                    defaultMessage="New login URL: {url}"
                    values={{
                        url: (
                            <a href={loginUrl} className="tw-text-primary">
                                {loginUrl}
                            </a>
                        ),
                    }}
                />
            </p>
            <BackToLoginLink />
        </div>
    );
};
